const other = {
    state: {
        caseRemark: '',//病例备注
        doctorAdvice:'',//医嘱模板
        doctorAdviceIds:'',
    },
    mutations: {
        SET_CASE_REMARK: (state, newVal) => {
            state.caseRemark = newVal
        },
        SET_DOCTOR_ADVICE: (state, newVal) => {
            state.doctorAdvice = newVal
        },
        SET_DOCTOR_ADVICEIDS: (state, newVal) => {
            state.doctorAdviceIds = newVal
        }
    }
}
export default other


// WEBPACK FOOTER //
// ./src/store/modules/other.js